import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  keyboardDatePicker: {
    color: "#000000 !important",
    "& .$MuiPickersDatePickerRoot-toolbar": {
      display: "none",
    },
  },
  profilePicture: {
    [theme.breakpoints.down("sm")]: {
      order: -1,
      paddingBottom: "80px !important",
    },
  },
  paddingForContact: {
    paddingTop: "0px !important",
  },
  calendarColor: {
    backgroundColor: "#00A3A3",
  },
  textFieldLato: {
    borderColor: "#0F172A",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: "24px",
    color: "#0F172A",
  },
  fontColor: {
    color: "#000000 !important",
  },
  labelToggle: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "24px",
  },
  label: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "space-between",
      paddingRight: "10px",
    },
  },
  spouse: {
    textAlign: "left !important" as "left",
    paddingTop: "50px !important",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px !important",
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  smsNotification: {
    paddingTop: "40px",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      display: "flex",
      justifyContent: "space-between",
      paddingRight: "10px",
      "& .MuiFormGroup-root": {
        display: "contents !important",
      },
    },
  },
  switch: {
    fontFamily: "Inter !important",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    width: 28,
    height: 16,
    padding: 0,
    marginLeft: "10px",
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      color: "#fff",
      "&.Mui-checked": {
        transform: "translateX(12px)",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#000000",
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.12,
        },
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.12,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "#000000",
      boxSizing: "border-box",
    },
  },
  formGroup: {
    [theme.breakpoints.down("sm")]: {
      display: "contents",
    },
  },
  buttons: {
    display: "flex",
  },
  cancelButton: {
    width: "102px",
    height: "42px",
    display: "flex",
    padding: "12px 24px",
    background: "#F1F5FF",
    color: "#0344DC",
    borderRadius: "100px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    margin: 0,
  },
  saveButton: {
    width: "86px",
    height: "42px",
    display: "flex",
    padding: "12px 24px",
    background: "#0344DC",
    color: "#FFFFFF",
    borderRadius: "100px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "19px",
    margin: 0,
  },
  retirementAgeOfSpouse: {
    padding: "16px",
    flexBasis: "10%",
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      maxWidth: "100%",
      flexBasis: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px",
    },
  },
  spouseAnnualIncome: {
    flexBasis: "17%",
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  annualIncomeAndRetirement: {
    whiteSpace: "nowrap",
    width: "100% !important",
    "& .MuiFormLabel-root": {
      borderColor: "#0F172A",
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "24px",
      color: "#0F172A",
    },
  },
  inputLabelDropdown: {
    borderColor: "#0F172A",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "24px",
    color: "#0F172A",
  },
  inputField: {
    paddingBottom: "10px",
    color: "#0F172A",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "24px",
  },
  textField: {
    paddingBottom: "20px",
    width: "60% !important",
    display: "flex",
    "& .MuiFormLabel-root": {
      borderColor: "#0F172A",
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "24px",
      color: "#0F172A",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
  },
  textFieldContact: {
    width: "100% !important",
    paddingBottom: "0px",
  },
  widthItems: {
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      width: "100% !important",
      maxWidth: "100% !important",
      flexBasis: "100% !important",
    },
  },
  secondaryEmail: {
    width: "79% !important",
    paddingBottom: "0px",
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      width: "100% !important",
      maxWidth: "100% !important",
      flexBasis: "100% !important",
    },
  },
  inputLabel: {
    borderColor: "#0F172A",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "24px",
    color: "#0F172A",
  },
  maritalStatus: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "24px",
    color: "#0F172A",
  },
  calendarHeader: {
    color: "#F1F5F9",
  },
  toolBarCalendar: {
    display: "none",
  },
  dateOfBirth: {
    width: "40% !important",
    MuiPickersDatePickerRoot: {
      toolbar: {
        display: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      flexGrow: 0,
      width: "100% !important",
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  mainTitle: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(30),
    color: "#0F172A",
  },
  title: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
    lineHeight: "24px",
    color: "#000000",
  },
  root: {
    flexGrow: 1,
  },
  titleSeparator: {
    width: "100%",
    height: "auto",
    margin: "0 553.8px 1.5px 0.3px",
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.33",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#353535",
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    padding: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
    },
  },
  numbers: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    padding: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2),
    },
  },
  bottom: {
    marginBottom: theme.spacing(1),
  },
  form: {
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  hide: {
    display: "none",
  },
  btnSuccess: {
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "green !important",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "100%",
  },
  separate: { border: "solid 0.8px #e4eaec" },
  primaryEmail: {
    color: "inherit",
    "& .MuiInputBase-input.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.87)",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  logoutButton: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: "black",
    background: "#fafbfc",
    padding: "8px 24px",
    gap: "8px",
    borderRadius: "100px",
    "&:hover": {
      background: "#E6F1FF",
      color: "black",
    },
  },
  logOutIcon: {
    color: "black",
  },
}));
